import TitleCard from '../components/TitleCard';
import Logo from '../components/Logo';
import { Row, Col, Button } from 'react-bootstrap';
import ValidationInput from '../components/ValidationTextInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { passwordValidation, confirmPasswordValidation } from '../services/validation';
import { useAPI } from '../services/api';
import { useLocation } from 'react-router-dom';
import '../styles/components/custom-buttons.scss';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ToastContext from '../store/toast-context';

const ResetPasswordPage = ({ title = 'Reset Password' }) => {
  const api = useAPI();
  const location = useLocation();
  const url = location.pathname.split('reset/');
  const hash = url[url.length - 1];
  const { success, handleError } = useContext(ToastContext);
  const history = useHistory();

  const dataSchema = Yup.object().shape({
    password: passwordValidation(),
    confirmPassword: confirmPasswordValidation(),
  });

  const initialValues = {
    password: '',
    confirmPassword: '',
  };

  const submitClicked = async ({ password }) => {
    try {
      await api.put(`/users/reset/${hash}`, { password });
      success('Password Reset Successfully');
      history.push('/');
    } catch (err) {
      console.error(err);
      handleError(err);
    }
  };

  return (
    <>
      <Logo />
      <Row className="mb-5">
        <Col xs={11} s={9} md={6} className="mx-auto">
          <TitleCard title={title} cardWidth={'60%'}>
            <Formik
              onSubmit={submitClicked}
              initialValues={initialValues}
              validationSchema={dataSchema}
            >
              <Form className="p-3 text-center">
                <ValidationInput
                  name="password"
                  aria-label="password-input"
                  label=""
                  placeholder="Password"
                  password
                />
                <ValidationInput
                  name="confirmPassword"
                  aria-label="confirm-password-input"
                  label=""
                  placeholder="Confirm Password"
                  password
                />
                <Button type="submit" className="dark-btn">
                  Submit
                </Button>
              </Form>
            </Formik>
          </TitleCard>
        </Col>
      </Row>
    </>
  );
};

export default ResetPasswordPage;
